import EmptyUserInfo from './EmptyUserInfo'

export default EmptyUserInfo
